<template>
  <div class="login-page">
    <div class="login-container">
      <div class="login-header">
        <div class="icon">📊</div>
        <h1>欢迎回来</h1>
        <p>懂车帝口碑数据分析系统</p>
      </div>

      <div v-if="errorMessage" class="error-message">
        {{ errorMessage }}
      </div>

      <form @submit.prevent="handleLogin">
        <div class="form-group">
          <label for="username">用户名</label>
          <input
            v-model="username"
            type="text"
            id="username"
            placeholder="请输入用户名"
            autocomplete="username"
            required
          >
        </div>

        <div class="form-group">
          <label for="password">密码</label>
          <input
            v-model="password"
            type="password"
            id="password"
            placeholder="请输入密码"
            autocomplete="current-password"
            required
            @keypress.enter="handleLogin"
          >
        </div>

        <button type="submit" class="btn-login" :disabled="loading">
          {{ loading ? '登录中...' : '登录' }}
        </button>
      </form>

      <div class="footer">
        © 2024 懂车帝口碑分析系统
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Login',
  data() {
    return {
      username: '',
      password: '',
      errorMessage: '',
      loading: false
    }
  },
  mounted() {
    // 如果已登录，直接跳转到主页
    if (localStorage.getItem('isLoggedIn') === 'true') {
      this.$router.push('/')
    }
  },
  methods: {
    handleLogin() {
      this.errorMessage = ''
      this.loading = true

      // 模拟网络延迟
      setTimeout(() => {
        const VALID_CREDENTIALS = {
          username: 'admin',
          password: 'huayao.2026'
        }

        if (this.username === VALID_CREDENTIALS.username && 
            this.password === VALID_CREDENTIALS.password) {
          // 登录成功
          localStorage.setItem('isLoggedIn', 'true')
          localStorage.setItem('username', this.username)
          localStorage.setItem('loginTime', new Date().toISOString())
          // 设置默认角色为普通用户
          localStorage.setItem('userRole', '普通用户')
          localStorage.setItem('userRoleValue', 'normal_user')
          
          // 跳转到主页
          this.$router.push('/')
        } else {
          // 登录失败
          this.errorMessage = '用户名或密码错误，请重试'
          this.password = ''
          this.loading = false
        }
      }, 600)
    }
  }
}
</script>

<style scoped>
.login-page {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  padding: 20px;
}

.login-container {
  background: white;
  border-radius: 16px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
  padding: 48px 40px;
  width: 100%;
  max-width: 420px;
  animation: slideUp 0.4s cubic-bezier(.22,.61,.36,1);
}

@keyframes slideUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.login-header {
  text-align: center;
  margin-bottom: 40px;
}

.login-header h1 {
  font-size: 28px;
  color: #2d3748;
  margin-bottom: 8px;
  font-weight: 700;
}

.login-header p {
  color: #718096;
  font-size: 14px;
}

.form-group {
  margin-bottom: 24px;
}

.form-group label {
  display: block;
  margin-bottom: 8px;
  color: #4a5568;
  font-size: 14px;
  font-weight: 500;
}

.form-group input {
  width: 100%;
  padding: 12px 16px;
  border: 2px solid #e2e8f0;
  border-radius: 8px;
  font-size: 15px;
  transition: all 0.2s ease;
  outline: none;
}

.form-group input:focus {
  border-color: #667eea;
  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
}

.btn-login {
  width: 100%;
  padding: 14px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  border: none;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  margin-top: 8px;
}

.btn-login:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 8px 20px rgba(102, 126, 234, 0.4);
}

.btn-login:active {
  transform: translateY(0);
}

.btn-login:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  transform: none;
}

.error-message {
  background: #fed7d7;
  color: #c53030;
  padding: 12px 16px;
  border-radius: 8px;
  margin-bottom: 20px;
  font-size: 14px;
  animation: shake 0.3s;
}

@keyframes shake {
  0%, 100% { transform: translateX(0); }
  25% { transform: translateX(-10px); }
  75% { transform: translateX(10px); }
}

.footer {
  text-align: center;
  margin-top: 32px;
  color: #a0aec0;
  font-size: 13px;
}

.icon {
  width: 64px;
  height: 64px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border-radius: 16px;
  margin: 0 auto 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 32px;
}
</style>

